<div class="pt-2" [ngClass]="{'d-none d-sm-flex': hideIfMobile, 'd-flex': !hideIfMobile, 'flex-row gap-2': !isMobile, 'row':isMobile}">
<ng-template [ngIf]="tenant">
    <div class="border br-8 bg-white w-35 box-shadow d-flex align-items-center justify-content-center lh-8px" [ngClass]="{'font-14': isMobile, 'flex-column': !isModal, 'carac-modal': isModal}">
      <span class="d-block font-16 material-icons" >cake</span>
      {{ room.tenant.age > 0 ? room.tenant.age + ' ' + ( 'COMMON.YEAR_OLD' | translate) : '' }}
    </div>

    <div class="border br-8 bg-white w-35 box-shadow d-flex align-items-center justify-content-center lh-8px" [ngClass]="{'font-14': isMobile, 'flex-column': !isModal, 'carac-modal': isModal}">
      <img *ngIf="room.tenant.nationality && room.tenant.nationality.length == 2" class="flag-img"
           alt="{{room.tenant.nationality}}" src="https://purecatamphetamine.github.io/country-flag-icons/3x2/{{ room.tenant.nationality }}.svg"/>
      <span *ngIf="!room.tenant.nationality || room.tenant.nationality.length != 2">🏴</span>
      {{ room.tenant.nationality && room.tenant.nationality.length == 2 ? room.tenant.nationality : 'N/A' }}
    </div>

    <div class="border br-8 bg-white w-35 box-shadow d-flex align-items-center justify-content-center lh-8px" [ngClass]="{'font-14': isMobile, 'flex-column': !isModal, 'carac-modal': isModal}">
      <span class="material-icons-outlined d-block font-14">
        <img [src]="getGender(room.tenant.gender)" height="16" />
      </span>
      {{getGenderKey(room.tenant.gender)  | translate}}
    </div>


</ng-template>

<ng-template [ngIf]="!tenant &&  room.status == 'Listed' && isModal && isCarac">
<!-- surface -->
  <div *ngIf="room['meter']" class="border text_3 br-8 bg-white py-2 px-3 box-shadow d-flex align-items-center justify-content-center lh-8px" [ngClass]="{'font-14': isMobile, 'flex-column': !isModal, 'carac-modal': isModal, 'w-50':isMobile}">
      <lf-icon class="icon-carac" name="space" width="16px" height="16px" fillColor="#FFFFFF" [ngClass]="isMobile ? 'font-24' : 'font-14' "></lf-icon>
    {{ room['meter'] ? room['meter'] + 'm²' : 'N/A' }}
  </div>

<!-- tenants -->
  <div class="border text_3 br-8 bg-white py-2 px-3 text-nowrap box-shadow d-flex align-items-center justify-content-center lh-8px"
    [ngClass]="{'font-14': isMobile, 'flex-column': !isModal, 'carac-modal': isModal, 'w-50':isMobile}" *ngIf="room.partner_type == 'room' && room['tenants']">
    <lf-icon class="icon-carac" name="Coloc" width="16px" height="16px" fillColor="#FFFFFF" [ngClass]="isMobile ? 'font-24' : 'font-14' "></lf-icon>
    {{ room['tenants'] + ' ' + ('PROCESSES.ACCOMMODATION.COLOCS' | translate) }}
  </div>

  <!-- mendatory_gender -->
  <div class="border text_3 br-8 bg-white py-2 px-3 text-nowrap box-shadow d-flex align-items-center justify-content-center lh-8px"
    [ngClass]="{'font-14': isMobile, 'flex-column': !isModal, 'carac-modal': isModal, 'w-50':isMobile}" *ngIf="room.mendatory_gender">
    <lf-icon class="icon-carac" [name]="room.mendatory_gender == 'M' ? 'male' : 'female'" width="16px" height="16px" fillColor="#FFFFFF" [ngClass]="isMobile ? 'font-24' : 'font-14' "></lf-icon>
    {{ room.mendatory_gender == 'M' ?  ('COMMON.MENDATORY_GENDER.MENDATORY_MEN' | translate) : ('COMMON.MENDATORY_GENDER.MENDATORY_FEMALE' | translate)  }}
  </div>

<!-- nb chambres -->
  <div *ngIf="room.nb_rooms && (room.partner_type == 'house' || room.partner_type == 'studio' || room.partner_type == 'apartment')" class="border text_3 br-8 bg-white py-2 px-3 box-shadow d-flex align-items-center justify-content-center lh-8px" [ngClass]="{'font-14': isMobile, 'flex-column': !isModal, 'carac-modal': isModal, 'w-50':isMobile}"
       >
      <lf-icon class="icon-carac" name="bed" width="16px" height="16px" fillColor="#FFFFFF" [ngClass]="isMobile ? 'font-24' : 'font-14' "></lf-icon>
    {{ room.nb_rooms ? room.nb_rooms : 'N/A' }}
  </div>

<!-- meublé -->
  <div class="border text_3 br-8 bg-white py-2 px-3 box-shadow d-flex align-items-center justify-content-center lh-8px" [ngClass]="{'font-14': isMobile, 'flex-column': !isModal, 'carac-modal': isModal, 'w-50':isMobile}"
       *ngIf="room.partner_type == 'building'">
      <lf-icon class="icon-carac" name="wardrobe" width="16px" height="16px" fillColor="#FFFFFF" [ngClass]="isMobile ? 'font-24' : 'font-14' "></lf-icon>
    {{ (room.is_furnished ? 'PROCESSES.ACCOMMODATION.FURNISHED' : 'PROCESSES.ACCOMMODATION.NOT_FURNISHED') | translate }}
  </div>

  <!-- SDB -->
  <div *ngIf="room['bathrooms_private'] !== null" class="border text_3 br-8 bg-white py-2 px-3 box-shadow d-flex align-items-center justify-content-center lh-8px" [ngClass]="{'font-14': isMobile, 'flex-column': !isModal, 'carac-modal': isModal, 'w-50':isMobile}"
 >
      <lf-icon [ngClass]="isMobile ? 'font-24' : 'font-14' " class="icon-carac" fillColor="#FFFFFF" height="16px" name="shower"
               width="16px"></lf-icon>
    {{ (room['bathrooms_private'] === null ? 'N/A' : room.bathrooms_private  ? 'COMMON.PRIVATE' : 'COMMON.SHARED') | translate }}
  </div>

<!-- toilettes -->
  <div class="border text_3 br-8 bg-white py-2 px-3 box-shadow d-flex align-items-center justify-content-center lh-8px" [ngClass]="{'font-14': isMobile, 'flex-column': !isModal, 'carac-modal': isModal, 'w-50':isMobile}"
  *ngIf="numberDisplay && numberDisplay >= 4 && room.wc_private !== null"
  >
    <lf-icon [ngClass]="isMobile ? 'font-24' : 'font-14' " class="icon-carac" fillColor="#FFFFFF" height="16px" name="Toilet"
             width="16px"></lf-icon>
    {{ (room.wc_private === null ? 'N/A' : room.wc_private ? 'COMMON.PRIVATE' : 'COMMON.SHARED') | translate }}
  </div>

  <!-- Residence étudiante -->
  <div class="border text_3 br-8 bg-white py-2 px-3 box-shadow d-flex align-items-center justify-content-center lh-8px" [ngClass]="{'font-14': isMobile, 'flex-column': !isModal, 'carac-modal': isModal, 'w-50':isMobile}"
  *ngIf="numberDisplay && numberDisplay >= 4 && room.isStudentResidence"
  >
    <lf-icon [ngClass]="isMobile ? 'font-24' : 'font-14' " class="icon-carac" fillColor="#FFFFFF" height="16px" name="deck"
             width="16px"></lf-icon>
             <span class="text_2">{{ 'PROCESSES.ACCOMMODATION.AMENITIES.STUDENT-RESIDENCE' | translate }}</span>
  </div>

</ng-template>
<ng-template [ngIf]="!tenant &&  room.status == 'Listed' && !isModal && !isCarac">
        <!-- surface -->
        <div *ngIf="room['meter']" class="border br-8 bg-white w-35 box-shadow d-flex align-items-center justify-content-center lh-8px" [ngClass]="{'font-14': isMobile, 'flex-column': !isModal, 'carac-modal': isModal}">
            <lf-icon name="space" width="24px" height="24px" fillColor="#1C69FF" [ngClass]="isMobile ? 'font-24' : 'font-14' "></lf-icon>
            {{ room['meter'] ? room['meter'] + 'm²' : 'N/A' }}
        </div>

        <!-- tenants -->
        <div class="border br-8 bg-white px-3 text-nowrap box-shadow d-flex align-items-center justify-content-center lh-8px"
          [ngClass]="{'font-14': isMobile, 'flex-column': !isModal, 'carac-modal': isModal}" *ngIf="room.partner_type == 'room' && room['tenants']">
          <lf-icon name="Coloc" width="24px" height="24px" fillColor="#1C69FF" [ngClass]="isMobile ? 'font-24' : 'font-14' "></lf-icon>
          {{ room['tenants'] + ' ' + ('PROCESSES.ACCOMMODATION.COLOCS' | translate) }}
        </div>

          <!-- mendatory_gender -->
          <div class="border text_3 br-8 bg-white px-3 text-nowrap box-shadow d-flex align-items-center justify-content-center lh-8px"
          [ngClass]="{'font-14': isMobile, 'flex-column': !isModal, 'carac-modal': isModal, 'w-50':isMobile}" *ngIf="room.mendatory_gender">
          <lf-icon class="icon-carac" [name]="room.mendatory_gender == 'M' ? 'male' : 'female'" width="16px" height="16px" fillColor="#FFFFFF" [ngClass]="isMobile ? 'font-24' : 'font-14' "></lf-icon>
          {{ room.mendatory_gender == 'M' ?  ('COMMON.MENDATORY_GENDER.MENDATORY_MEN' | translate) : ('COMMON.MENDATORY_GENDER.MENDATORY_FEMALE' | translate)  }}
        </div>

        <!-- nb chambres -->
        <div *ngIf="room.nb_rooms && (room.partner_type == 'house' || room.partner_type == 'studio' || room.partner_type == 'apartment')" class="border br-8 bg-white w-35 box-shadow d-flex align-items-center justify-content-center lh-8px" [ngClass]="{'font-14': isMobile, 'flex-column': !isModal, 'carac-modal': isModal}"
        >
            <lf-icon name="bed" width="24px" height="24px" fillColor="#1C69FF" [ngClass]="isMobile ? 'font-24' : 'font-14' "></lf-icon>
            {{ room.nb_rooms ? room.nb_rooms : 'N/A' }}
        </div>

        <!-- meublé -->
        <div class="border br-8 bg-white w-35 box-shadow d-flex align-items-center justify-content-center lh-8px" [ngClass]="{'font-14': isMobile, 'flex-column': !isModal, 'carac-modal': isModal}"
             *ngIf="room.partner_type == 'building'">
            <lf-icon name="wardrobe" width="24px" height="24px" fillColor="#1C69FF" [ngClass]="isMobile ? 'font-24' : 'font-14' "></lf-icon>
            {{ (room.is_furnished ? 'PROCESSES.ACCOMMODATION.FURNISHED' : 'PROCESSES.ACCOMMODATION.NOT_FURNISHED') | translate }}
        </div>

        <!-- SDB -->
        <div *ngIf="room['bathrooms_private'] !== null" class="border br-8 bg-white w-35 box-shadow d-flex align-items-center justify-content-center lh-8px" [ngClass]="{'font-14': isMobile, 'flex-column': !isModal, 'carac-modal': isModal}"
        >
            <lf-icon name="shower" width="24px" height="24px" fillColor="#1C69FF" [ngClass]="isMobile ? 'font-24' : 'font-14' "></lf-icon>
            {{ (room['bathrooms_private'] === null ? 'N/A' : room.bathrooms_private  ? 'COMMON.PRIVATE' : 'COMMON.SHARED') | translate }}
        </div>

        <!-- toilettes -->
        <div class="border br-8 bg-white w-35 box-shadow d-flex align-items-center justify-content-center lh-8px"  [ngClass]="{'font-14': isMobile, 'flex-column': !isModal, 'carac-modal': isModal}"
             *ngIf="numberDisplay && numberDisplay >= 4 && room.wc_private !== null"
        >
            <lf-icon name="Toilet" width="24px" height="24px" fillColor="#1C69FF" [ngClass]="isMobile ? 'font-24' : 'font-14' "></lf-icon>
            {{ (room.wc_private === null ? 'N/A' : room.wc_private ? 'COMMON.PRIVATE' : 'COMMON.SHARED') | translate }}
        </div>

    </ng-template>

<ng-template [ngIf]="!tenant &&  room.status == 'Listed' && isModal && !isCarac">
        <!-- surface -->
        <div *ngIf="room['meter']" class="border text_3 br-8 bg-white w-35 box-shadow d-flex align-items-center justify-content-center lh-8px" [ngClass]="{'font-14': isMobile, 'flex-column': !isModal, 'carac-modal': isModal}">
            <lf-icon class="icon-carac" name="space" width="24px" height="24px" fillColor="#1C69FF" [ngClass]="isMobile ? 'font-24' : 'font-14' "></lf-icon>
            {{ room['meter'] ? room['meter'] + 'm²' : 'N/A' }}
        </div>

              <!-- tenants -->
        <div class="border text_3 br-8 bg-white px-3 text-nowrap box-shadow d-flex align-items-center justify-content-center lh-8px"
          [ngClass]="{'font-14': isMobile, 'flex-column': !isModal, 'carac-modal': isModal}" *ngIf="room.partner_type == 'room' && room['tenants']">
          <lf-icon class="icon-carac" name="Coloc" width="24px" height="24px" fillColor="#1C69FF" [ngClass]="isMobile ? 'font-24' : 'font-14' "></lf-icon>
          {{ room['tenants'] + ' ' + ('PROCESSES.ACCOMMODATION.COLOCS' | translate) }}
        </div>

              <!-- mendatory_gender -->
        <div class="border text_3 br-8 bg-white px-3 text-nowrap box-shadow d-flex align-items-center justify-content-center lh-8px"
          [ngClass]="{'font-14': isMobile, 'flex-column': !isModal, 'carac-modal': isModal}" *ngIf="room.mendatory_gender">
          <lf-icon class="icon-carac" [name]="room.mendatory_gender == 'M' ? 'male' : 'female'" width="24px" height="24px" fillColor="#1C69FF" [ngClass]="isMobile ? 'font-24' : 'font-14' "></lf-icon>
          {{ room.mendatory_gender == 'M' ?  ('COMMON.MENDATORY_GENDER.MENDATORY_MEN' | translate) : ('COMMON.MENDATORY_GENDER.MENDATORY_FEMALE' | translate)  }}
        </div>

      <!-- mendatory_gender -->
      <div class="border text_3 br-8 bg-white px-3 text-nowrap box-shadow d-flex align-items-center justify-content-center lh-8px"
      [ngClass]="{'font-14': isMobile, 'flex-column': !isModal, 'carac-modal': isModal}" *ngIf="room.mendatory_gender">
      <lf-icon class="icon-carac" [name]="room.mendatory_gender == 'M' ? 'male' : 'female'" width="24px" height="24px" fillColor="#1C69FF" [ngClass]="isMobile ? 'font-24' : 'font-14' "></lf-icon>
      {{ room.mendatory_gender == 'M' ?  ('COMMON.MENDATORY_GENDER.MENDATORY_MEN' | translate) : ('COMMON.MENDATORY_GENDER.MENDATORY_FEMALE' | translate)  }}
    </div>

        <!-- nb chambres -->
        <div *ngIf="room.nb_rooms && (room.partner_type == 'house' || room.partner_type == 'studio' || room.partner_type == 'apartment')" class="border text_3 br-8 bg-white w-35 box-shadow d-flex align-items-center justify-content-center lh-8px" [ngClass]="{'font-14': isMobile, 'flex-column': !isModal, 'carac-modal': isModal}"
        >
            <lf-icon class="icon-carac" name="bed" width="24px" height="24px" fillColor="#1C69FF" [ngClass]="isMobile ? 'font-24' : 'font-14' "></lf-icon>
            {{ room.nb_rooms ? room.nb_rooms : 'N/A' }}
        </div>

        <!-- meublé -->
        <div class="border text_3 br-8 bg-white w-35 box-shadow d-flex align-items-center justify-content-center lh-8px" [ngClass]="{'font-14': isMobile, 'flex-column': !isModal, 'carac-modal': isModal}"
             *ngIf="room.partner_type == 'building'">
            <lf-icon class="icon-carac" name="wardrobe" width="24px" height="24px" fillColor="#1C69FF" [ngClass]="isMobile ? 'font-24' : 'font-14' "></lf-icon>
            {{ (room.is_furnished ? 'PROCESSES.ACCOMMODATION.FURNISHED' : 'PROCESSES.ACCOMMODATION.NOT_FURNISHED') | translate }}
        </div>

        <!-- SDB -->
        <div *ngIf="room['bathrooms_private'] !== null" class="border text_3 br-8 bg-white w-35 box-shadow d-flex align-items-center justify-content-center lh-8px" [ngClass]="{'font-14': isMobile, 'flex-column': !isModal, 'carac-modal': isModal}"
        >
            <lf-icon class="icon-carac" name="shower" width="24px" height="24px" fillColor="#1C69FF" [ngClass]="isMobile ? 'font-24' : 'font-14' "></lf-icon>
            {{ (room['bathrooms_private'] === null ? 'N/A' : room.bathrooms_private  ? 'COMMON.PRIVATE' : 'COMMON.SHARED') | translate }}
        </div>

        <!-- toilettes -->
        <div class="border text_3 br-8 bg-white w-35 box-shadow d-flex align-items-center justify-content-center lh-8px"  [ngClass]="{'font-14': isMobile, 'flex-column': !isModal, 'carac-modal': isModal}"
             *ngIf="numberDisplay && numberDisplay >= 4 && room.wc_private !== null"
        >
            <lf-icon class="icon-carac" name="Toilet" width="24px" height="24px" fillColor="#1C69FF" [ngClass]="isMobile ? 'font-24' : 'font-14' "></lf-icon>
            {{ (room.wc_private === null ? 'N/A' : room.wc_private ? 'COMMON.PRIVATE' : 'COMMON.SHARED') | translate }}
        </div>

    </ng-template>


</div>

<div class="flex-row flex-column gap-16 text_2 pb-1">
    <ng-template [ngIf]="!tenant &&  room.status == 'Listed' && !isModal && isCarac">
        <!-- surface -->
        <div *ngIf="room['meter']" class="d-flex align-items-center mb-3 text_3">
            <lf-icon class="icon-carac" name="space" width="24px" height="24px" fillColor="#1C69FF"></lf-icon>
            {{ room['meter'] ? room['meter'] + 'm²' : 'N/A' }}
        </div>

        <!-- tenants -->
        <div class="d-flex align-items-center mb-3 text_3" *ngIf="room.partner_type == 'room' && room['tenants']">
          <lf-icon class="icon-carac" name="Coloc" width="24px" height="24px" fillColor="#1C69FF"></lf-icon>
          {{ room['tenants'] + ' ' + ('PROCESSES.ACCOMMODATION.COLOCS' | translate) }}
        </div>

        <!-- mendatory_gender -->
        <div class="d-flex align-items-center mb-3 text_3" *ngIf="room.mendatory_gender">
        <lf-icon class="icon-carac" [name]="room.mendatory_gender == 'M' ? 'male' : 'female'" width="24px" height="24px" fillColor="#1C69FF"></lf-icon>
        {{ room.mendatory_gender == 'M' ?  ('COMMON.MENDATORY_GENDER.MENDATORY_MEN' | translate) : ('COMMON.MENDATORY_GENDER.MENDATORY_FEMALE' | translate)  }}
        </div>

        <!-- nb chambres -->
        <div *ngIf="room.nb_rooms && (room.partner_type == 'house' || room.partner_type == 'studio' || room.partner_type == 'apartment')" class="d-flex align-items-center mb-3 text_3">
            <lf-icon class="icon-carac" name="bed" width="24px" height="24px" fillColor="#1C69FF"></lf-icon>
            {{ room.nb_rooms ? room.nb_rooms : 'N/A' }}
        </div>

        <!-- meublé -->
        <div class="d-flex align-items-center mb-3" *ngIf="room.partner_type == 'building'">
            <lf-icon class="icon-carac" name="wardrobe" width="24px" height="24px" fillColor="#1C69FF"></lf-icon>
            {{ (room.is_furnished ? 'PROCESSES.ACCOMMODATION.FURNISHED' : 'PROCESSES.ACCOMMODATION.NOT_FURNISHED') | translate }}
        </div>

        <!-- SDB -->
        <div *ngIf="room['bathrooms_private'] !== null" class="d-flex align-items-center mb-3 text_3">
            <lf-icon class="icon-carac" name="shower" width="24px" height="24px" fillColor="#1C69FF"></lf-icon>
            {{ (room['bathrooms_private'] === null ? 'N/A' : room.bathrooms_private  ? 'COMMON.PRIVATE' : 'COMMON.SHARED') | translate }}
        </div>

        <!-- toilettes -->
        <div class="d-flex align-items-center mb-3 text_3"
             *ngIf="numberDisplay && numberDisplay >= 4 && room.wc_private !== null">
            <lf-icon class="icon-carac" name="Toilet" width="24px" height="24px" fillColor="#1C69FF"></lf-icon>
            {{ (room.wc_private === null ? 'N/A' : room.wc_private ? 'COMMON.PRIVATE' : 'COMMON.SHARED') | translate }}
        </div>

    </ng-template>
</div>
